import React, { useCallback, useEffect, useState } from "react";
import dynamic from "@redux-dynostore/react-redux";
import subspaced from "@redux-dynostore/react-redux-subspace";
import { attachReducer } from "@redux-dynostore/redux-subspace";
import { connect } from "react-redux";
import AuditTrailFilters from "../../library/AuditTrailFilters/AuditTrailFilters";
import {
  mapDispatchToProps,
  mapStateToProps,
  auditTrailReducer,
} from "./AuditTrail.store";

import AuditTrailEventsTable from "../../library/AuditTrailEventsTable/AuditTrailEventsTable";
import { sendNotification } from "../../ToastManager/ToastManager";
import { ToastType } from "../../ToastManager/constants";
import {
  AUDIT_TRAIL_EVENTS_PAGE_SIZE,
  AUDIT_TRAIL_PARAMS_NAMES,
  DateFormat,
} from "../../../modules/constants";
import { updateURLQueryParams } from "../../../modules/utils";
import moment from "moment";

export const SmartAuditTrail = (props) => {
  const {
    filterBefore,
    filterAfter,
    filterActor,
    filterActorType,
    filterSubjectAccount,
    filterAction,
    filterStatus,
    filterSubjectSite,
    filterResource,
    fetchDictionaries,
    fetchAuditEvents,
    fetchAuditEventsByFilters,
    actorTypes,
    resetEvents,
    actions,
    statuses,
    events,
    sites,
    user_sites,
    fetchSites,
    filterTags,
    updateEvents,
    toggleEventsData,
  } = props;

  const [hasMoreData, setHasMoreData] = useState(true);

  useEffect(() => {
    fetchDictionaries()
      .then((r) => {
        return r;
      })
      .catch((error) => {
        sendNotification(error, ToastType.ERROR);
      });
  }, [fetchDictionaries]);

  useEffect(() => {
    if (sites?.length === 0 && user_sites?.length === 0) {
      fetchSites();
    }
  }, [sites, user_sites]);

  const applyFilters = (filters) => {
    resetEvents();
    setHasMoreData("loading");

    fetchAuditEventsByFilters(filters)
      .then((r) => {
        if (r === 0) {
          setHasMoreData("noresults");
        } else setHasMoreData(r < AUDIT_TRAIL_EVENTS_PAGE_SIZE ? false : true);
      })
      .catch((error) => {
        sendNotification(error, ToastType.ERROR);
      });
  };

  const removeFilterTagAndApplyFilters = useCallback(
    (filterTag) => {
      const filters = {
        filterBefore:
          filterTag.id === AUDIT_TRAIL_PARAMS_NAMES.before
            ? null
            : filterBefore,
        filterAfter:
          filterTag.id === AUDIT_TRAIL_PARAMS_NAMES.after ? null : filterAfter,
        filterActor:
          filterTag.id === AUDIT_TRAIL_PARAMS_NAMES.actor ? null : filterActor,
        filterActorType:
          filterTag.id === AUDIT_TRAIL_PARAMS_NAMES.actorType
            ? null
            : filterActorType,
        filterSubjectAccount:
          filterTag.id === AUDIT_TRAIL_PARAMS_NAMES.subjectAccount
            ? null
            : filterSubjectAccount,
        filterAction:
          filterTag.id === AUDIT_TRAIL_PARAMS_NAMES.action
            ? null
            : filterAction,
        filterStatus:
          filterTag.id === AUDIT_TRAIL_PARAMS_NAMES.status
            ? null
            : filterStatus,
        filterSubjectSite:
          filterTag.id === AUDIT_TRAIL_PARAMS_NAMES.subjectSite
            ? null
            : filterSubjectSite,
        filterResource:
          filterTag.id === AUDIT_TRAIL_PARAMS_NAMES.resource
            ? null
            : filterResource,
      };

      applyFilters(filters);

      updateURLQueryParams(filterTag.id, "", "/audittrail");
    },
    [
      filterBefore,
      filterAfter,
      filterActor,
      filterActorType,
      filterSubjectAccount,
      filterAction,
      filterStatus,
      filterSubjectSite,
      filterResource,
    ]
  );

  const onChangeActorType = useCallback(
    (value) => {
      applyFilters({
        filterAfter: filterAfter,
        filterBefore: filterBefore,
        filterActor: filterActor,
        filterActorType: value,
        filterSubjectAccount: filterSubjectAccount,
        filterAction: filterAction,
        filterStatus: filterStatus,
        filterSubjectSite: filterSubjectSite,
        filterResource: filterResource,
      });

      updateURLQueryParams(
        AUDIT_TRAIL_PARAMS_NAMES.actorType,
        value,
        "/audittrail"
      );
    },
    [
      filterBefore,
      filterAfter,
      filterActor,
      filterSubjectAccount,
      filterAction,
      filterStatus,
      filterSubjectSite,
      filterResource,
    ]
  );

  const onChangeAction = useCallback(
    (value) => {
      applyFilters({
        filterAfter: filterAfter,
        filterBefore: filterBefore,
        filterActor: filterActor,
        filterActorType: filterActorType,
        filterSubjectAccount: filterSubjectAccount,
        filterAction: value,
        filterStatus: filterStatus,
        filterSubjectSite: filterSubjectSite,
        filterResource: filterResource,
      });

      updateURLQueryParams(
        AUDIT_TRAIL_PARAMS_NAMES.action,
        value,
        "/audittrail"
      );
    },
    [
      filterBefore,
      filterAfter,
      filterActor,
      filterSubjectAccount,
      filterActorType,
      filterStatus,
      filterSubjectSite,
      filterResource,
    ]
  );

  const onChangeStatus = useCallback(
    (value) => {
      applyFilters({
        filterAfter: filterAfter,
        filterBefore: filterBefore,
        filterActor: filterActor,
        filterActorType: filterActorType,
        filterSubjectAccount: filterSubjectAccount,
        filterAction: filterAction,
        filterStatus: value,
        filterSubjectSite: filterSubjectSite,
        filterResource: filterResource,
      });

      updateURLQueryParams(
        AUDIT_TRAIL_PARAMS_NAMES.status,
        value,
        "/audittrail"
      );
    },
    [
      filterBefore,
      filterAfter,
      filterActor,
      filterSubjectAccount,
      filterActorType,
      filterAction,
      filterSubjectSite,
      filterResource,
    ]
  );

  const onChangeSite = useCallback(
    (value) => {
      applyFilters({
        filterAfter: filterAfter,
        filterBefore: filterBefore,
        filterActor: filterActor,
        filterActorType: filterActorType,
        filterSubjectAccount: filterSubjectAccount,
        filterAction: filterAction,
        filterStatus: filterStatus,
        filterSubjectSite: value,
        filterResource: filterResource,
      });

      updateURLQueryParams(
        AUDIT_TRAIL_PARAMS_NAMES.subjectSite,
        value,
        "/audittrail"
      );
    },
    [
      filterBefore,
      filterAfter,
      filterActor,
      filterSubjectAccount,
      filterActorType,
      filterAction,
      filterStatus,
      filterResource,
    ]
  );

  const applyActorFilter = useCallback(
    (value) => {
      applyFilters({
        filterAfter: filterAfter,
        filterBefore: filterBefore,
        filterActor: value,
        filterActorType: filterActorType,
        filterSubjectAccount: filterSubjectAccount,
        filterAction: filterAction,
        filterStatus: filterStatus,
        filterSubjectSite: filterSubjectSite,
        filterResource: filterResource,
      });

      updateURLQueryParams(
        AUDIT_TRAIL_PARAMS_NAMES.actor,
        value,
        "/audittrail"
      );
    },
    [
      filterBefore,
      filterAfter,
      filterSubjectAccount,
      filterActorType,
      filterAction,
      filterStatus,
      filterSubjectSite,
      filterResource,
    ]
  );

  const applySubjectAccountFilter = useCallback(
    (value) => {
      applyFilters({
        filterAfter: filterAfter,
        filterBefore: filterBefore,
        filterActor: filterActor,
        filterActorType: filterActorType,
        filterSubjectAccount: value,
        filterAction: filterAction,
        filterStatus: filterStatus,
        filterSubjectSite: filterSubjectSite,
        filterResource: filterResource,
      });

      updateURLQueryParams(
        AUDIT_TRAIL_PARAMS_NAMES.subjectAccount,
        value,
        "/audittrail"
      );
    },
    [
      filterBefore,
      filterAfter,
      filterActor,
      filterActorType,
      filterAction,
      filterStatus,
      filterSubjectSite,
      filterResource,
    ]
  );

  const applyResourceFilter = useCallback(
    (value) => {
      applyFilters({
        filterAfter: filterAfter,
        filterBefore: filterBefore,
        filterActor: filterActor,
        filterActorType: filterActorType,
        filterSubjectAccount: filterSubjectAccount,
        filterAction: filterAction,
        filterStatus: filterStatus,
        filterSubjectSite: filterSubjectSite,
        filterResource: value,
      });

      updateURLQueryParams(
        AUDIT_TRAIL_PARAMS_NAMES.resource,
        value,
        "/audittrail"
      );
    },
    [
      filterBefore,
      filterAfter,
      filterActor,
      filterActorType,
      filterAction,
      filterStatus,
      filterSubjectSite,
      filterSubjectAccount,
    ]
  );

  const onChangeBeforeAfterDateTimes = useCallback(
    (before, after) => {
      applyFilters({
        filterAfter: after ?? filterAfter,
        filterBefore: before ?? filterBefore,
        filterActor: filterActor,
        filterActorType: filterActorType,
        filterSubjectAccount: filterSubjectAccount,
        filterAction: filterAction,
        filterStatus: filterStatus,
        filterSubjectSite: filterSubjectSite,
        filterResource: filterResource,
      });

      if (before) {
        updateURLQueryParams(
          AUDIT_TRAIL_PARAMS_NAMES.before,
          moment(before).format(DateFormat.DATE_TIME),
          "/audittrail"
        );
      }

      if (after) {
        updateURLQueryParams(
          AUDIT_TRAIL_PARAMS_NAMES.after,
          moment(after).format(DateFormat.DATE_TIME),
          "/audittrail"
        );
      }
    },
    [
      filterBefore,
      filterAfter,
      filterActor,
      filterActorType,
      filterAction,
      filterStatus,
      filterSubjectSite,
      filterSubjectAccount,
      filterResource,
    ]
  );

  return (
    <div style={{ position: "relative" }} data-testid="at-container">
      <AuditTrailFilters
        actorTypes={actorTypes}
        actions={actions}
        statuses={statuses}
        {...{ applyFilters }}
        filterTags={filterTags}
        removeFilterTag={removeFilterTagAndApplyFilters}
        {...{ user_sites }}
        {...{ onChangeActorType }}
        {...{ onChangeAction }}
        {...{ onChangeStatus }}
        {...{ onChangeSite }}
        {...{ applyActorFilter }}
        {...{ applySubjectAccountFilter }}
        {...{ applyResourceFilter }}
        {...{ onChangeBeforeAfterDateTimes }}
        {...{ toggleEventsData }}
        sites={sites}
      />

      <AuditTrailEventsTable
        {...{ events }}
        {...{ fetchAuditEventsByFilters }}
        {...{ fetchAuditEvents }}
        {...{ hasMoreData }}
        {...{ setHasMoreData }}
        {...{ user_sites }}
        {...{ fetchSites }}
        {...{ onChangeActorType }}
        {...{ onChangeAction }}
        {...{ onChangeStatus }}
        {...{ onChangeSite }}
        {...{ applyActorFilter }}
        {...{ applySubjectAccountFilter }}
        {...{ applyResourceFilter }}
        {...{ onChangeBeforeAfterDateTimes }}
        {...{ updateEvents }}
        sites={sites}
        actorTypes={actorTypes}
        actions={actions}
        statuses={statuses}
        filterTags={filterTags}
      />
    </div>
  );
};

export default dynamic(
  "auditTrailReducer",
  subspaced({
    // We map extra state because we might need to acess other stores for data, subspace is self contained.
    mapExtraState: (state, rootState) => ({
      loginReducer: state.loginReducer,
    }),
  }),
  attachReducer(auditTrailReducer)
)(connect(mapStateToProps, mapDispatchToProps)(SmartAuditTrail));
